var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4,5.8c1.1,0,1.9,0.9,1.9,2.1C5.9,9,5.2,10,4,10c-1.1,0-1.9-0.9-1.9-2.1C2.2,6.7,2.9,5.8,4,5.8 M5.9,11.8H8V0H5.9v3.6\n\tc0,0.5,0.1,1.2,0.1,1.5C5.6,4.4,4.7,3.9,3.6,3.9C1.5,3.9,0,5.6,0,7.9S1.6,12,3.6,12c1.1,0,1.9-0.5,2.3-1.2L5.9,11.8L5.9,11.8z\n\t M16.8,4.1h-6.4v1.9h3.8L10.5,10v1.8h6.4V10H13l3.8-4.1V4.1z M26.5,8.5c0-3.2-1.8-4.6-3.9-4.6c-2.2,0-3.8,1.7-3.8,4.1\n\ts1.7,4.1,3.9,4.1c1.7,0,3-0.8,3.7-2.4l-2.2-0.2c-0.3,0.5-0.9,0.8-1.5,0.8c-0.9,0-1.6-0.7-1.7-1.5h5.5L26.5,8.5L26.5,8.5L26.5,8.5z\n\t M22.6,5.7c0.9,0,1.5,0.7,1.6,1.4h-3.3C21.1,6.2,21.8,5.7,22.6,5.7 M30.8,0h-2.1v11.8h2.1V8.6h0.5l2.2,3.2H36l-3-4.2l2.9-3.5h-2.5\n\tl-2.1,2.7h-0.5L30.8,0L30.8,0z"}));
}

Logo.defaultProps = {"width":"36px","height":"12px","viewBox":"0 0 36 12"};

module.exports = Logo;

Logo.default = Logo;
